import { GOOGLE_MAPS_KEY } from 'shared/helpers/globals';

type GoogleStreetViewLocation =
  | { type: 'address'; street: string; city: string; state: string }
  | { type: 'coordinates'; latitude: number; longitude: number };
type GoogleStreetViewOptions = { width?: number; height?: number };

/** Google street view image url */
export const googleStreetViewUrl = (
  location: GoogleStreetViewLocation,
  options?: GoogleStreetViewOptions,
): string => {
  const locationString =
    location.type === 'address'
      ? `${location.street}, ${location.city}, ${location.state}`
      : `${location.latitude},${location.longitude}`;
  const width = options?.width || 768;
  const height = options?.height || 512;

  return (
    'https://maps.googleapis.com/maps/api/streetview?' +
    `&size=${width}x${height}` +
    `&location=${encodeURIComponent(locationString)}` +
    `&key=${encodeURIComponent(GOOGLE_MAPS_KEY)}`
  );
};
